import '../polyfills/smoothscroll.min';

// Anchors links 
(() => {
	const mask = /#[a-z0-9\-_]+/i;
	
	const anchorLinks = Array.from(document.querySelectorAll('a[href*=\\#]'));
	anchorLinks.forEach(a => {
		const results = mask.exec(a.getAttribute('href'));
		if(! results || results.length === 0 ) {
			return;
		}
		
		if(! document.querySelector(results[0])) {
			return;
		}
		
		a.dataset.ref = results[0];
		a.addEventListener('click', event => {
			event.preventDefault();
			document.querySelector(event.currentTarget.dataset.ref).scrollIntoView({ behavior: 'smooth' });
			
		});
	});
})();